export enum NAMESPACE {
  COMMON = 'common',
  LOGIN_PAGE = 'loginPage',
  MEDIA_PLAN_PAGE = 'mediaPlanPage',
  USER_SETTINGS_PAGE = 'userSettingsPage',
  RATE_CARDS_PAGE = 'rateCardsPage',
  BOOKING_SHEET_PAGE = 'bookingSheetPage'
}
